import { select } from "../../../core/elements/index.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import entrySorter from "../folders/entrySorter.js";
import sortingStrategies from "../folders/sortingStrategies.js";

/**
 * Renders a select to choose a sorting strategies in the iconic view breadcrumb
 *
 * @param {function} onChange - Called when the user selects a new sorting strategy.
 */
export default class IconicSortingWidget extends Widget {
	constructor({ onChange } = {}) {
		super(...arguments);

		this._onChange = onChange;
		this._items = [];

		[
			sortingStrategies.sortByNameAZStrategy,
			sortingStrategies.sortByNameZAStrategy,
			sortingStrategies.sortByCreationTimeAscStrategy,
			sortingStrategies.sortByCreationTimeDescStrategy,
			sortingStrategies.sortByModificationTimeAscStrategy,
			sortingStrategies.sortByModificationTimeDescStrategy,
		].forEach((sortingStrategy) =>
			this._items.push({
				label: sortingStrategy.name(),
				value: sortingStrategy,
			}),
		);

		this._selected = this._items[0].value;
	}

	renderContentOn(html) {
		html.div(
			{ klass: "sortDiv" },
			select({
				class: "sortWidget",
				items: this._items,
				selected: this._selected,
				onChange: (value) => {
					this._selected = value;
					entrySorter.setCurrentStrategy(value);
					this._onChange();
				},
			}),
		);
	}
}
